import {
    Directive,
    ElementRef,
    input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';

/**
 * Diretiva que coloca o foco no Input que a utilizar.
 *
 */
@Directive({
    selector: '[aiFocus]',
    standalone: true,
})
export class FocusDirective implements OnChanges {
    focused = input.required<boolean>();
    selectContent = input<boolean>(false);

    constructor(private el: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['focused']) {
            if (this.selectContent()) {
                this.el.nativeElement.select();
            }

            this.el.nativeElement.focus();
        }
    }
}
